import formatMessages from 'utils/format-messages.js';

angular
.module('inkfinder')
.factory('Messages', function Messages(
  $q,
  $http,
  ENDPOINT,
  AlertMessages,
  filterFilter,
  Session
) {
  // Public functions
  Messages.create = create;
  Messages.get = get;

  /**
   * @name get
   * @description Function to get a conversation from the api
   * @param {number} conversationId The ID number of the converstation to
   * retrieve
   * @param {number} appointmentId The ID of the appointment of the conversation
   * @param {number} collectorId The ID of the logged in collector
   * @return {object} data Returns the conversation object.
   */
  function get(conversationId, appointmentId, collectorId) {
    let url = ENDPOINT.server + 'conversations/api/v1.1/messages/';
    let role = Session.activeState.role;
    url += '?role=' + role;
    if (conversationId) {
      url += '&conversation_id=' + conversationId;
    }
    if (appointmentId) {
      url += '&appointment_id=' + appointmentId;
    }
    if (collectorId) {
      url += '&collector_id=' + collectorId;
    }
    return $http.get(url).then(function(response) {
      const formattedMessaged = formatMessages(response.data);
      return formattedMessaged;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name create
   * @description create a Message
   * @param {object} message The message to create.
   * @return {object} Returns the new message object.
   */
  function create(message) {
    message.role = Session.activeState.role;
    if (Session.activeState.association) {
      message.association_id = Session.activeState.association.id;
    }
    return $http.post(ENDPOINT.server +
    'conversations/api/v1.1/messages/', message)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return Messages;
});



// WEBPACK FOOTER //
// ./components/messages/messages.service.js